import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { apiDocsEnvironmentsApiRef } from './api/ApiDocsEnvironmentsApi';
import { ApiDocsEnvironmentsClient } from './api/ApiDocsEnvironmentsClient';

export const apiDocsEnvironmentsPlugin = createPlugin({
  id: 'api-docs-environments',
  apis: [
    createApiFactory({
      api: apiDocsEnvironmentsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ApiDocsEnvironmentsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * The API page's definition card, with a tab per environment that has
 * published a definition. Use it for APIs that pass
 * {@link isApiDefinitionEnvironmentsAvailable}; others keep the stock
 * `EntityApiDefinitionCard`.
 */
export const EntityApiEnvironmentsDefinitionCard =
  apiDocsEnvironmentsPlugin.provide(
    createComponentExtension({
      name: 'EntityApiEnvironmentsDefinitionCard',
      component: {
        lazy: () =>
          import('./components/EntityApiEnvironmentsDefinitionCard').then(
            m => m.EntityApiEnvironmentsDefinitionCard,
          ),
      },
    }),
  );
